import { darken, lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: calc(100% - 64px);
`;

export const Map = styled.div`
  width: 100%;
  height: 100%;
`;

export const Button = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 18px;
  border-radius: 5px;
  font-family: 'Sora', sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #d00f0f;
  border: none;
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;

  span {
    display: flex;
    align-items: center;
  }

  background-color: #d00f0f;
  color: #ffffff;

  &:hover:not(:disabled) {
    background-color: ${darken(0.1, '#d00f0f')};
  }

  &:disabled {
    background-color: rgba(0, 0, 0, 0.12);
  }
`;

export const FloatContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Content = styled.div`
  font-family: 'Sora', sans-serif;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  z-index: 1;
  width: 300px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

  header {
    text-align: center;
    padding: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};

    h2 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.black};
      font-size: 20px;
      letter-spacing: 0px;
    }
  }

  main {
    padding: 16px;
    display: flex;
    gap: 6px;
    flex-direction: column;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        font-size: 14px;

        strong {
          font-weight: 600;
        }
      }

      div {
        display: flex;
        gap: 5px;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border: none;
          border-radius: 4px;

          &:nth-child(1) {
            background: ${({ theme }) => lighten(0.35, theme.colors.main)};

            span {
              color: ${({ theme }) => theme.colors.main};
              font-size: 18px;
            }

            &:hover {
              background: ${({ theme }) => lighten(0.3, theme.colors.main)};
            }
          }

          &:nth-child(2) {
            background: ${lighten(0.35, '#F64444')};

            span {
              color: ${'#F64444'};
              font-size: 18px;
            }

            &:hover {
              background: ${lighten(0.3, '#F64444')};
            }
          }
        }
      }

      & + div {
        padding-top: 6px;
        border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
      }
    }

    > button {
      margin-top: 10px;
    }
  }
`;

export const ModalContainer = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  width: 420px;
  border-radius: 8px;
  background-color: #fff;
`;

export const ModalHeader = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 10px 0;
`;

export const ModalBody = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: max-content;
  padding: 0px 40px 36px 40px;
`;
